import React from 'react';
import { Button, Modal } from 'antd';
import Cookies from 'js-cookie';

import { useTranslation } from 'app/i18n-config';
import { UserConfig } from 'app/models/user-config';
import { AppContext } from 'app/app-context';

const COOKIE_TERMS_ACCEPTED = 'TERMS_ACCEPTED';

export const isTermsAccepted = (config: UserConfig | null) => {
  return Cookies.get(COOKIE_TERMS_ACCEPTED) === config?.termsContent;
};

export const acceptTerms = (config: UserConfig | null) => {
  if (!config?.termsContent) {
    return;
  }

  Cookies.set(COOKIE_TERMS_ACCEPTED, config.termsContent, { expires: 0 });
};

interface Props {
  visible: boolean;
  onAccept: () => void;
}

export const Terms: React.FC<Props> = ({ visible, onAccept }) => {
  const { t } = useTranslation();
  const { config } = React.useContext(AppContext);

  if (!config?.termsContent) {
    return null;
  }

  return (
    <Modal
      open={visible}
      centered={true}
      closable={false}
      title={config.termsTitle || t('terms.title')}
      width={1000}
      footer={[
        <Button key="agree" type="primary" onClick={onAccept}>
          {t('terms.agreeButton')}
        </Button>,
      ]}
    >
      <div>
        <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{config.termsContent}</pre>
      </div>
    </Modal>
  );
};
